import { useEffect, useState } from 'react';

const useScrollYOfWindow = () => {
  const [scrollY, setScrollY] = useState<number>();

  useEffect(() => {
    const updateScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', updateScroll);

    return () => window.removeEventListener('scroll', updateScroll);
  }, []);

  return scrollY;
};

export default useScrollYOfWindow;
